<template>
  <div v-if="!!infoDialog">
    <component :is="infoDialog" v-model="modelValue" />
  </div>
</template>

<script>
import { Component, ComputedOptions } from 'vue'
import { Computed } from '@/_typedefs'
import InhaledCorticosteroidDialogVue from './Dialogs/InhaledCorticosteroidDialog.vue'
import SpirometryDialogVue from './Dialogs/SpirometryDialog.vue'
import OmalizumabDialogVue from './Dialogs/MedicinePrescription/OmalizumabDialog.vue'

export default {
  name: 'InfoDialogActivatorComponent',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    info: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dialog: {
        info: false,
      },
    }
  },
  computed: {
    /** @type {ComputedOptions<boolean>} */
    modelValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    /** @type {Computed<Component | null>} */
    infoDialog() {
      if (!this.info) {
        return null
      }

      const dialogMap = {
        'asthma:inhaled-corticosteroid': InhaledCorticosteroidDialogVue,
        'asthma:spirometry': SpirometryDialogVue,
        'asthma:medicine-prescription--omalizumab': OmalizumabDialogVue,
      }

      return dialogMap[this.info] ?? null
    },
  },
}
</script>

<style></style>
